<template>
  <nav class="main-header navbar navbar-expand navbar-white navbar-light">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" data-widget="pushmenu" href="#" role="button">
          <i class="fa fa-bars"></i></a>
      </li>
    </ul>
    
    <ul class="navbar-nav ml-auto">
      <!-- Navbar Search -->

      <!-- Notifications Dropdown Menu -->
      <li class="nav-item dropdown">
          <a id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" class="nav-link dropdown-toggle" href="#">
           <i class="fa fa-user"></i> {{ usuario.nombre }}
          </a>
          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
            <a href="#" class="dropdown-item" @click.prevent="salir">
              <i class="fa fa-sign-out-alt"></i>
              <span class="float-right text-muted text-sm">salir</span>
            </a>
          </div>
      </li>
    </ul>
  </nav>
</template>
<script>
  import axios from 'axios';
  import TokenService from '../services/token.service';

  export default {
    name: 'AppMenu',
    props: {
      usuario: {
        type: Object,
        required: true
      }
    },
    methods: {
      salir () {
        console.log('Saliendo')
        axios.post(this.UrlAdmin+'/sesion/logout');
        TokenService.removeAccessToken();
        window.location.href = '/';
      }
    }
  }
</script>